import { z } from "zod";

// Bounds are a sanity backstop (no DB CHECK constraint — see
// .claude/rules/database.md, this codebase validates ranges at the zod
// boundary), not a business rule: 1 day minimum, ~10 years maximum.
const retentionDaysSchema = z.number().int().min(1).max(3650);

/**
 * Body for `PUT /api/admin/soap-call-log-settings`. `errorRetentionDays:
 * null` means "keep error/failed rows forever" — see
 * src/db/schema/soap-api-call-log.ts.
 */
export const updateSoapApiLogSettingsSchema = z.object({
  loggingEnabled: z.boolean(),
  successRetentionDays: retentionDaysSchema,
  errorRetentionDays: retentionDaysSchema.nullable(),
});

export type UpdateSoapApiLogSettingsInput = z.infer<typeof updateSoapApiLogSettingsSchema>;
